export default __webpack_public_path__ + "static/media/DP2 2B-2EC V04.e94ca225.jpg";